import { SuperAdminDbMetricsPage } from "../../operator/console/super-admin-db-metrics";

export default function ConsoleSuperAdminDbMetrics() {
  return <SuperAdminDbMetricsPage />;
}
